import { _removeCertainAttrsFromSomeNodes, _removeMark } from 'common/Prose/Commands/marks'
import { cleanupTableOfContentsFormatting } from 'common/Prose/nodeViews/TableOfContents/utils'
import { preserveSelection } from 'common/Prose/utils'
import { schema } from 'prose-core'
import { NodeSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'

export const useClearFormattingButton = (view: EditorView) => {
  return () => {
    setTimeout(() => {
      const { tr, selection } = view.state
      // TODO: Make this generic and still controllable from the editor
      if (selection instanceof NodeSelection && selection.node.type === schema.nodes.table_of_contents) {
        cleanupTableOfContentsFormatting(view)
        return
      }
      _removeMark()(tr)
      _removeCertainAttrsFromSomeNodes(tr)
      preserveSelection(tr, view.state)
      view.dispatch(tr)
      view.focus()
    })
  }
}
